// module.reserves (contract §4.8.1): ReservesModule (UnderwayModules.tsx): the
// first fuel tank's level as a large readout, counted to the reserve line
// ("40% above reserve"), beside the house bank's net current, its charge and
// which way it is going (charging in green; nothing while idle).

import { css, h } from "./kit.js";
import { F } from "./module-kit.js";

export function moduleReserves() {
  return {
    html: h(
      "div",
      { class: "rs" },
      h(
        "div",
        { class: "rd" },
        h("span", { class: "rd-l", ...F("fuel-label") }),
        h(
          "span",
          { class: "rd-row rd-lg" },
          h("span", { class: "rd-v rs-v", ...F("fuel") }),
          h("span", { class: "rd-u" }, "%"),
        ),
        h("span", { class: "mo-sub", ...F("fuel-sub") }),
      ),
      h(
        "div",
        { class: "rs-p" },
        h(
          "div",
          { class: "rd" },
          h("span", { class: "rd-l", ...F("bank-label") }),
          h(
            "span",
            { class: "rd-row rd-md" },
            h("span", { class: "rd-v", ...F("current") }),
            h("span", { class: "rd-u" }, "A"),
          ),
        ),
        h("span", { class: "mo-sub", ...F("charge") }),
        h("span", { class: "rs-f", ...F("flow") }),
      ),
    ),
    css: css(`
      .rs { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; align-items: start; }
      .rs-v { font-weight: 700; }
      .rs .rd-v[data-quality=stale], .rs .rd-v[data-quality=missing] { color: var(--muted); }
      /* At night a stale value keeps the text colour: grey under the night tint reads below the app's own values (§9.6, TOM-665). */
      html[data-theme=night] .rs .rd-v[data-quality=stale] { color: var(--text); }
      .rs-p { display: flex; flex-direction: column; gap: 6px; align-items: flex-start; }
      .rs-f { font-size: 13px; font-weight: 600; color: var(--muted); }
      .rs-f[data-tone=good] { color: var(--good); }
      .rs-f:empty { display: none; }
    `),
  };
}
